import React from "react";
import { Building2, LifeBuoy, SearchCheck, Shield, Calculator as CalcIcon } from "lucide-react";

const services = [
  {
    icon: Building2,
    title: "Budowa firmy od podstaw",
    desc:
      "Pomagam stworzyć firmę transportową lub spedycyjną od zera — od modelu biznesowego, przez pierwszych klientów, aż po skalowanie.",
    bullets: ["Model biznesowy", "Pierwsi klienci", "Skalowanie"],
  },
  {
    icon: LifeBuoy,
    title: "Restrukturyzacja i wyjście z kryzysu",
    desc:
      "Jeśli firma ma problemy finansowe, brak płynności lub chaos operacyjny — pomagam odzyskać kontrolę i wyprowadzić biznes na prostą.",
    bullets: ["Plan naprawczy", "Kontrola płynności", "Negocjacje z wierzycielami"],
  },
  {
    icon: SearchCheck,
    title: "Audyt i optymalizacja",
    desc:
      "Analizuję firmę pod kątem kosztów, rentowności, procesów i struktury operacyjnej — wskazuję konkretne działania naprawcze.",
    bullets: ["Koszty i marże", "Procesy operacyjne", "Struktura zespołu"],
  },
  {
    icon: CalcIcon,
    title: "Optymalizacja podatkowa i struktury",
    desc:
      "Pomagam uporządkować strukturę firmy i zoptymalizować podatki w sposób bezpieczny i zgodny z prawem.",
    bullets: ["Struktura spółki", "Bezpieczne rozwiązania", "Zgodność z prawem"],
  },
  {
    icon: Shield,
    title: "Weryfikacja klientów i ograniczanie ryzyka",
    desc:
      'Sprawdzanie kontrahentów, ustalanie limitów kupieckich, unikanie „min" finansowych — żebyś nie pracował za darmo.',
    bullets: ["Weryfikacja kontrahentów", "Limity kupieckie", "Windykacja prewencyjna"],
  },
];

export default function Services() {
  return (
    <section id="oferta" data-testid="services-section" className="section border-t border-[rgba(212,169,74,0.08)] relative">
      <div className="container-x">
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((s, idx) => {
            const Icon = s.icon;
            const isLast = idx === services.length - 1;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${idx}`}
                className={`card-dark p-8 lg:p-10 ${isLast ? "md:col-span-2" : ""}`}
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="flex-1">
                    <div className="flex items-center gap-4">
                      <div className="h-12 w-12 border border-[rgba(212,169,74,0.35)] flex items-center justify-center">
                        <Icon className="text-[var(--gold)]" size={22} strokeWidth={1.4} />
                      </div>
                      <span className="font-display text-[14px] tracking-[0.3em] text-[var(--gold)]">
                        0{idx + 1}
                      </span>
                    </div>
                    <h3 className="h-display text-[24px] md:text-[28px] mt-6 text-[#f5f1e8]">
                      {s.title}
                    </h3>
                    <p className="mt-4 text-[15px] leading-relaxed text-[#b8b3a7]">
                      {s.desc}
                    </p>
                    <div className="mt-6 flex flex-wrap gap-2">
                      {s.bullets.map((b) => (
                        <span
                          key={b}
                          className="text-[11px] uppercase tracking-[0.18em] text-[#e8e3d5] border border-[rgba(212,169,74,0.25)] px-3 py-1.5"
                        >
                          {b}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
